import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { TextButton, InfoWidget } from '@ds/react-components';
import Table from 'components/ui/Table';
import { List as ListLoader } from 'react-content-loader';
import { Typography, Grid } from '@material-ui/core';
import moment from 'moment';

const styles = (theme) => ({
  textGray: {
    color: theme.palette.xpl.text.secondary,
  },
  textBlack: {
    color: theme.palette.xpl.text.primary,
  },
  textBold: {
    color: theme.palette.xpl.text.primary,
  },
  gridCell: {
    height: '40px',
    width: '100%',
  },
  table: {
    color: theme.palette.xpl.text.primary,
    tableLayout: 'fixed',
  },
  loader: {
    height: 150,
    width: '100%',
  },
});

const getCallNotesForDisplay = (callNotes, localisation, classes) => {
  return callNotes.map((cNote) => {
    let callNote = { ...cNote };
    const dateFormat = localisation.locales.dateTimeFormat;

    let { notes } = callNote;

    callNote.notesFld = (
      <Grid container className={classes.gridCell} direction="row">
        <Grid item xs={12}>
          <Typography className={classes.textBlack} noWrap>
            {notes}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.textGray}>
            by {callNote.fullName}
          </Typography>
        </Grid>
      </Grid>
    );

    callNote.callHowFld = (
      <Grid className={classes.gridCell}>
        <Typography className={classes.textBold} noWrap>
          {localisation.prompts.callHow[callNote.callHow]}
        </Typography>
      </Grid>
    );

    callNote.callWhenFld = (
      <Grid className={classes.gridCell}>
        <Typography className={classes.textGray}>
          {moment(callNote.callWhen).format(dateFormat)}
        </Typography>
      </Grid>
    );

    return callNote;
  });
};

const tableMetadata = [
  {
    id: 'callHow',
    renderingField: 'callHowFld',
    width: '15%',
    numeric: false,
    disablePadding: false,
    alignment: 'left',
  },
  {
    id: 'notes',
    renderingField: 'notesFld',
    width: '60%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    alignment: 'left',
  },
  {
    id: 'callWhen',
    renderingField: 'callWhenFld',
    width: '25%',
    numeric: false,
    disablePadding: false,
    alignment: 'left',
  },
];

const ActivitiesPreview = (props) => {
  const { classes, customerDetails, localisation } = props;
  const { adfitNo, callNotes } = customerDetails;
  const activities =
    callNotes && getCallNotesForDisplay(callNotes, localisation, classes);
  return (
    <InfoWidget
      title="Activities"
      actionButton={
        <Link to={`/Customers/${adfitNo}/Activities`}>
          <TextButton>View All</TextButton>
        </Link>
      }
      isLoading={!adfitNo || callNotes == null}
      contentLoader={<ListLoader className={classes.loader} />}
      classes={{ root: classes.root }}>
      <Table
        classes={{ table: classes.table }}
        data={activities}
        metadata={tableMetadata}
        noBackground={true}
        enableSorting={false}
        showFooter={false}
      />
    </InfoWidget>
  );
};

ActivitiesPreview.propTypes = {
  classes: PropTypes.object.isRequired,
  customerDetails: PropTypes.object,
};

export default withStyles(styles)(ActivitiesPreview);
